import { render, staticRenderFns } from "./MilestoneListItem.vue?vue&type=template&id=1a8896fc&scoped=true"
import script from "./MilestoneListItem.vue?vue&type=script&lang=js"
export * from "./MilestoneListItem.vue?vue&type=script&lang=js"
import style0 from "./MilestoneListItem.vue?vue&type=style&index=0&id=1a8896fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8896fc",
  null
  
)

export default component.exports